/**
 * Models - Configuración de modelos 3D para el Playground
 *
 * Para añadir tus propios modelos:
 * 1. Coloca el archivo en src/assets/models/
 * 2. Añade una entrada aquí con la configuración
 *
 * Formatos soportados: GLB, GLTF, FBX, OBJ
 * Recomendado: GLB (binario, texturas embebidas, más eficiente)
 */

import type { Model3D } from '@/types';

// Modelos de ejemplo usando glTF Sample Models (Khronos Group)
// Puedes reemplazarlos con tus propios modelos locales
export const models: Model3D[] = [
  {
    id: 'robot',
    name: 'Robot',
    description: 'Robot animado con articulaciones móviles',
    path: 'https://threejs.org/examples/models/gltf/RobotExpressive/RobotExpressive.glb',
    format: 'glb',
    scale: 0.5,
    hasAnimations: true,
  },
  {
    id: 'littlest-tokyo',
    name: 'Littlest Tokyo',
    description: 'Escena urbana estilizada con animaciones',
    path: 'https://threejs.org/examples/models/gltf/LittlestTokyo.glb',
    format: 'glb',
    scale: 0.01,
    hasAnimations: true,
  },
  {
    id: 'soldier',
    name: 'Soldier',
    description: 'Modelo de personaje con animación de caminar',
    path: 'https://threejs.org/examples/models/gltf/Soldier.glb',
    format: 'glb',
    scale: 1,
    hasAnimations: true,
  },
];

export function getRandomModelIndex(): number {
  return Math.floor(Math.random() * models.length);
}
